import { Component, ChangeDetectionStrategy } from '@angular/core';

import { PmReportsTeamDatasourceService } from '../../services';

@Component({
  selector: 'mg-pm-reports-team',
  template: `
    <mg-report-table
      matSort
      [dataSourceService]="ds"
      (matSortChange)="ds.sort($event)">
    </mg-report-table>
  `,
  styleUrls: ['../pm-reports.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PmReportsTeamDatasourceService],
})
export class PmReportsTeamComponent {
  constructor(public ds: PmReportsTeamDatasourceService) {}
}
